import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/registrieren/Registrieren.js");
